export default "__VITE_ASSET__CK$4uqwv__"